import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ErrorProvider } from "./context/ErrorContext";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme.js';
import Navbar from "./components/Navbar";
import LandingPage from "./components/LandingPage";
import RedirectToWork from "./components/RedirectToWork";

const App = () => (
  <ThemeProvider theme={theme}>
    <ErrorProvider>
      <Router>
        <Navbar />
        <Routes>
              {/* Landing Page */}
              <Route path="/" element={<LandingPage />} />

              {/* All opportunities routes redirect to work URL */}
              <Route path="/opportunities/*" element={<RedirectToWork path="/opportunities" />} />
              <Route path="/job/*" element={<RedirectToWork path="/opportunities" />} />
              <Route path="/jobs/*" element={<RedirectToWork path="/opportunities" />} />
              
              {/* Redirects to Work App - All work-related features now handled by REACT_APP_WORK_URL */}
              <Route path="/manage-self" element={<RedirectToWork path="/manage-self" />} />
              <Route path="/profile" element={<RedirectToWork />} />
              <Route path="/profile/:id" element={<RedirectToWork />} />
              <Route path="/dashboard" element={<RedirectToWork />} />
              <Route path="/application" element={<RedirectToWork />} />
              <Route path="/my-application/:id" element={<RedirectToWork />} />
            </Routes>
          </Router>
      </ErrorProvider>
    </ThemeProvider>
);

export default App;
